import { HttpHeaders, HttpParameterCodec } from '@angular/common/http';
import { CustomHttpParameterCodec } from './encoder';
import { Configuration } from './configuration';
import { OpenApiHttpParams, QueryParamStyle } from './query.params';
import { environment } from '../../environments/environment';

export class BaseService {
  protected basePath = environment.apiUrl;
  public defaultHeaders = new HttpHeaders();
  public configuration: Configuration;
  public encoder: HttpParameterCodec;

  constructor(basePath?: string | string[], configuration?: Configuration) {
    this.configuration = configuration ?? new Configuration();
    if (typeof this.configuration.basePath !== 'string') {
      const first = Array.isArray(basePath) ? basePath[0] : basePath;
      this.configuration.basePath = first ?? this.basePath;
    }
    this.encoder = this.configuration.encoder ?? new CustomHttpParameterCodec();
  }

  protected addToHttpParams(
    httpParams: OpenApiHttpParams,
    key: string,
    value: unknown,
    _style: QueryParamStyle,
    _explode: boolean,
  ): OpenApiHttpParams {
    if (value === null || value === undefined) {
      return httpParams;
    }
    return httpParams.append(key, String(value));
  }
}
